import React, {useState} from "react";
import {
  closePopup,
  getValue,
  handleImgError,
  imageChangeEvent,
  inputMaxLength, removeArrayById, removeArrayByIndex,
  setChecked,
  setValue
} from "../../../static/js/Common2";
import closeV2 from "../../../static/image/v2/popup/closeV2.png";
import imgAddBtn from "../../../static/image/v2/popup/imgAddBtn.png";
import imgRemoveBtn from "../../../static/image/v2/imgRemoveBtn.png";
import {telFormat} from "../../../static/js/service/formatService";
import {modifyShopInfo1} from "../../../static/js/service/shopService";
import KakaoMap from "../../map/kakaoMap";
import {openPopup} from "../../../utils/CommonUtils";

const ShopInfo1PopupV22 = React.memo(({shopInfo, isLogoChanged, setIsLogoChanged}) => {
  const [fileList, setFileList] = useState([]);

  if(shopInfo.shopStatus === 6) {
    setChecked("shopStates1", true);
  } else if(shopInfo.shopStatus === 7 || shopInfo.shopStatus === 5) {
    setChecked("shopStates2", true);
  }

  if(shopInfo.mobile !== "") {
    const mobile = telFormat(shopInfo.mobile);
    const mobileArr = mobile.split("-");
    setValue("shopTel1", mobileArr[0]);
    setValue("shopTel2", mobileArr[1]);
    setValue("shopTel3", mobileArr[2]);
  }

  const modiBtnEvent = () => {
    const shopName = getValue("realNameInput");
    const shopTel = `${getValue("shopTel1")}${getValue("shopTel2")}${getValue("shopTel3")}`;
    const deliCmplTm = getValue("deliCmplTm");
    const wrapCmplTm = getValue("wrapCmplTm");
    const shopInformation = getValue("shopInformation");
    const shopNotice = getValue("shopNotice");
    const shopRoad = getValue("roadInput");
    const shopLat = getValue("latInput");
    const shopLng = getValue("lngInput");
    const shopJibun = getValue("jibunInput");
    const shopAddressDetail = getValue("addressDetailInput");

    let newFileList = [];
    let setFileList = [];
    let removeFileList = [];

    // 신규, 수정 이미지 리스트 조회
    fileList.forEach((value) => {
      if(value.id) {
        setFileList.push({
          id: value.id,
          encodedFile: value.encodedFile,
          fileName: value.fileName,
          fileExtension: value.fileExtension
        });
      } else {
        newFileList.push({
          imageType: value.imageType,
          encodedFile: value.encodedFile,
          fileName: value.fileName,
          fileExtension: value.fileExtension
        });
      }
    });

    // 삭제 이미지 리스트 조회
    const noticeImage = document.querySelectorAll(".noticePreview input");
    noticeImage.forEach((element) => {
      const dataId = Number(element.dataset.id);
      const dataModi = Number(element.dataset.modi);

      if(dataModi === 1) {
        removeFileList.push(dataId);
      }
    });

    let data = {
      shopId: shopInfo.shopId,
      addImageFileList: newFileList,
      setImageFileList: setFileList,
      removeImageFileIdList: removeFileList
    }

    // 로고를 실제로 변경한 경우에만 remove+add 반영 (하이드레이션으로 세팅된 기존 로고 id와 구분)
    if (isLogoChanged) {
      const addFreeImageIds = document.getElementById("logoPreview").getAttribute("data-id");
      const shopLogoImgId = document.getElementById("shopLogoImg").getAttribute("data-id");
      const shopLogoImgIdNum = Number(shopLogoImgId);

      // 1. removeImageFileIdList에 추가
      data.removeImageFileIdList = [
        ...(data.removeImageFileIdList || []),
        shopLogoImgIdNum
      ];

      // 2. setImageFileList에서 해당 항목 제거
      data.setImageFileList = (data.setImageFileList || []).filter(
        (item) => item.id !== shopLogoImgIdNum
      );

      // 3. addFreeImageIds는 배열로 추가
      data.addFreeImageIds = [Number(addFreeImageIds)];
    }

    if (shopInfo.shopStatus !== 8 && shopInfo.shopStatus !== 11 && shopInfo.shopStatus !== 12) {
      const shopStates = document.querySelector('input[name="shopStates"]:checked').value;
      data.status = Number(shopStates);
      data.prevStatus = Number(shopInfo.prevShopStates);
    }

    if (shopInfo.realName !== shopName) {
      data.name = shopName;
    }
    if (shopInfo.deliCmplTm !== Number(deliCmplTm)) {
      data.deliveryDoneMinutes = Number(deliCmplTm);
    }
    if (shopInfo.wrapCmplTm !== Number(wrapCmplTm)) {
      data.packagingDoneMinutes = Number(wrapCmplTm);
    }
    if (shopInfo.shopInformation !== shopInformation) {
      data.intro = shopInformation;
    }
    if (shopInfo.shopNotice !== shopNotice) {
      data.notice = shopNotice;
    }
    if (shopInfo.mobile !== shopTel) {
      data.tel = shopTel;
    }
    if (shopInfo.road !== shopRoad) {
      data.road = shopRoad;
    }
    if (shopInfo.lat !== shopLat) {
      data.lat = shopLat;
    }
    if (shopInfo.lng !== shopLng) {
      data.lng = shopLng;
    }
    if (shopInfo.jibun !== shopJibun) {
      data.jibun = shopJibun;
    }
    if (shopInfo.addressDetail !== shopAddressDetail) {
      data.addressDetail = shopAddressDetail;
    }

    //document.getElementById("shopInfo1Btn").setAttribute("disabled", true);
    modifyShopInfo1(data);
    setIsLogoChanged(false);
  }

  const imageChangeBtn = (e, maxSize, type, fileName, previewName, fileList, setFileList, number) => {
    imageChangeEvent(e, maxSize, type, fileName, previewName, fileList, setFileList);
    document.querySelector(`.imgRemoveBtn${number}`).classList.remove("hide");
  }

  const removeImageBtn = (e, number) => {
    const fileId = Number(e.target.dataset.id);
    const fileIndex = Number(e.target.dataset.index);

    document.querySelector(`.imgRemoveBtn${number}`).classList.add("hide");
    document.getElementById(`noticeImg${number}Preview`).setAttribute("src", "");

    if(fileId !== 0) {
      const fileListFilter = removeArrayById(fileList, fileId);
      document.getElementById(`noticeImg${number}`).setAttribute("data-modi", "1");
      setFileList(fileListFilter);
    } else {
      const fileListFilter = removeArrayByIndex(fileList, fileIndex);
      setFileList(fileListFilter);
    }
  }

  return (
    <>
      <KakaoMap />
      <div id="shopInfo1Popup" className="shopInfo1Popup popupV2 hide">
        <div className="popupContainer width808">
          <div className="popupTitle">
            {/* <h2>기본 정222222222222222보 수정</h2> */}
            <h2>기본 정보 수정</h2>
            <button className="closeBtn" onClick={() => { setIsLogoChanged(false); closePopup("shopInfo1Popup"); }}>
              <img src={closeV2} alt="취소" />
            </button>
          </div>
          <div className="popupContent">
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>로고</div>
              <div className='flexContent flexContentFlex'>
                <div className='shopLogoPreview'>
                  <input
                    id='shopLogoImg' name='shopLogoImg'
                    data-id="0" data-modi='0' data-index="0"
                    type='file' accept='image/jpeg, image/png' hidden
                    onChange={(e) => imageChangeEvent(
                      e, 560, 6, "", "logoPreview", fileList, setFileList
                    )}
                  />
                  <div className='preview'>
                    <img id="logoPreview" className='previewImg logoPreview' src='' alt='상점로고' onError={handleImgError} />
                  </div>
                </div>
                <div className='shopLogoImgBtnBox'>
                  <div className="d-flex a-start j-left mb-5">
                    <label htmlFor='shopLogoImg' id='shopLogoImgBtn'>
                      <img src={ imgAddBtn } alt='로고 변경' />
                    </label>
                    <button
                      type="text"
                      className="imageSearchBtn bg-blue fc-white ml-5"
                      onClick={() => openPopup("logoSearchPopup")}
                    >
                      이미지 검색
                    </button>
                  </div>
                  <p>※ 로고 이미지 권장 사이즈 500*500, 900KB이하의 jpg 또는 png 파일만 가능합니다.</p>
                </div>
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>상점명</div>
              <div className='flexContent'>
                <input
                  id='realNameInput' name='realNameInput' type='text'
                  maxLength={30} onInput={(e) => inputMaxLength(e)}
                  defaultValue={shopInfo.realName}
                />
              </div>
            </div>

            {shopInfo.shopStatus !== 8 && shopInfo.shopStatus !== 11 && shopInfo.shopStatus !== 12 &&
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>상태</div>
                <div className='flexContent'>
                  <div className='shopStatesBox'>
                    <input type='radio' name='shopStates' id='shopStates1' value={6} hidden />
                    <label htmlFor='shopStates1' className='shopStatesLabel shopStatesLabel1'>
                      영업 중
                    </label>
                    <input type='radio' name='shopStates' id='shopStates2' value={7} hidden />
                    <label htmlFor='shopStates2' className='shopStatesLabel shopStatesLabel2'>
                      영업중지
                    </label>
                  </div>
                </div>
              </div>
            }
            <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
              <div className='flexTitle'>상점 주소</div>
              <div className='flexContent'>
                <div className="d-flex a-center j-left">
                  <input
                    id='roadInput' name='roadInput' type='text'
                    defaultValue={shopInfo.road}
                    readOnly={true}
                  />
                  <button id="mapBtn" type="button" className="bg-blue fc-white">
                    주소 찾기
                  </button>
                </div>
                <input
                  id="latInput" name="latInput" type="hidden"
                  defaultValue={shopInfo.lat}
                />
                <input
                  id="lngInput" name="lngInput" type="hidden"
                  defaultValue={shopInfo.lng}
                />
                <input
                  id="jibunInput" name="jibunInput" type="hidden"
                  defaultValue={shopInfo.jibun}
                />
                <input
                  id='addressDetailInput' className="mt-5" name='addressDetailInput' type='text'
                  maxLength={50}
                  defaultValue={shopInfo.addressDetail}
                />
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>상점 연락처</div>
              <div className='flexContent'>
                <input
                  type='number' id='shopTel1' name='shopTel1' className='shopTel' maxLength={3}
                  onInput={(e) => inputMaxLength(e)}
                />
                -
                <input
                  type='number' id='shopTel2' name='shopTel2' className='shopTel' maxLength={4}
                  onInput={(e) => inputMaxLength(e)}
                />
                -
                <input
                  type='number' id='shopTel3' name='shopTel3' className='shopTel' maxLength={4}
                  onInput={(e) => inputMaxLength(e)}
                />
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>소요 예상시간</div>
              <div className='flexContent'>
                <div className='cmplTmBox cmplTmBox1'>
                  바로배달
                  <input
                    id='deliCmplTm' name='deliCmplTm' type='number' maxLength="3"
                    onInput={(e) => inputMaxLength(e)}
                    defaultValue={shopInfo.deliCmplTm} key={shopInfo.deliCmplTm}
                  />
                  분,
                </div>
                <div className='cmplTmBox cmplTmBox2'>
                  방문포장
                  <input
                    id='wrapCmplTm' name='wrapCmplTm' type='number' maxLength="3"
                    onInput={(e) => inputMaxLength(e)}
                    defaultValue={shopInfo.wrapCmplTm} key={shopInfo.wrapCmplTm}
                  />
                  분
                </div>
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
              <div className='flexTitle'>상점 소개</div>
              <div className='flexContent'>
                <textarea
                  id='shopInformation' name='shopInformation' placeholder='상점 소개 내용을 입력하세요.'
                  maxLength={500} defaultValue={shopInfo.shopInformation}
                />
              </div>
            </div>
            <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
              <div className='flexTitle'>상점 공지</div>
              <div className='flexContent'>
                <div className='noticeImgBox'>
                  <div className='preview noticePreview noticePreview1'>
                    <input
                      id='noticeImg1' name='noticeImg1'
                      data-id='0' data-modi='0' data-index="1"
                      type='file' accept='image/jpeg, image/png' hidden
                      onChange={(e) => imageChangeBtn(
                        e, 1280, 7, "", "noticeImg1Preview", fileList, setFileList, 1
                      )}
                    />
                    <button className='imgRemoveBtn imgRemoveBtn1 hide'>
                      <img src={ imgRemoveBtn } alt='이미지 삭제' data-id="0" data-index="1" onClick={(e) => removeImageBtn(e, 1)} />
                    </button>
                    <label htmlFor='noticeImg1'>
                      <img id="noticeImg1Preview" src='' alt='상점 공지' onError={handleImgError} />
                    </label>
                  </div>
                  <div className='preview noticePreview noticePreview2'>
                    <input
                      id='noticeImg2' name='noticeImg2'
                      data-id='0' data-modi='0' data-index="2"
                      type='file' accept='image/jpeg, image/png' hidden
                      onChange={(e) => imageChangeBtn(
                        e, 1280, 7, "", "noticeImg2Preview", fileList, setFileList, 2
                      )}
                    />
                    <button className='imgRemoveBtn imgRemoveBtn2 hide'>
                      <img src={ imgRemoveBtn } alt='이미지 삭제' data-id="0" data-index="2" onClick={(e) => removeImageBtn(e, 2)} />
                    </button>
                    <label htmlFor='noticeImg2'>
                      <img id="noticeImg2Preview" src='' alt='상점 공지' onError={handleImgError} />
                    </label>
                  </div>
                  <div className='preview noticePreview noticePreview3'>
                    <input
                      id='noticeImg3' name='noticeImg3'
                      data-id='0' data-modi='0' data-index="3"
                      type='file' accept='image/jpeg, image/png' hidden
                      onChange={(e) => imageChangeBtn(
                        e, 1280, 7, "", "noticeImg3Preview", fileList, setFileList, 3
                      )}
                    />
                    <button className='imgRemoveBtn imgRemoveBtn3 hide'>
                      <img src={ imgRemoveBtn } alt='이미지 삭제' data-id="0" data-index="3" onClick={(e) => removeImageBtn(e, 3)} />
                    </button>
                    <label htmlFor='noticeImg3'>
                      <img id="noticeImg3Preview" src='' alt='상점 공지' onError={handleImgError} />
                    </label>
                  </div>
                  <div className='preview noticePreview noticePreview4'>
                    <input
                      id='noticeImg4' name='noticeImg4'
                      data-id='0' data-modi='0' data-index="4"
                      type='file' accept='image/jpeg, image/png' hidden
                      onChange={(e) => imageChangeBtn(
                        e, 1280, 7, "", "noticeImg4Preview", fileList, setFileList, 4
                      )}
                    />
                    <button className='imgRemoveBtn imgRemoveBtn4 hide'>
                      <img src={ imgRemoveBtn } alt='이미지 삭제' data-id="0" data-index="4" onClick={(e) => removeImageBtn(e, 4)} />
                    </button>
                    <label htmlFor='noticeImg4'>
                      <img id="noticeImg4Preview" src='' alt='상점 공지' onError={handleImgError} />
                    </label>
                  </div>
                  {/**
                   <button className='noticePreviewBtn hide'>
                   <img src={ noticeBtn } alt='공지사진 추가' />
                   </button>
                   */}
                </div>
                <textarea
                  id='shopNotice' name='shopNotice' placeholder='상점 공지 내용을 입력하세요.'
                  maxLength={500} defaultValue={shopInfo.shopNotice}
                />
              </div>
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn stopCloseBtn' onClick={() => { setIsLogoChanged(false); closePopup("shopInfo1Popup"); }}>취소</button>
            <button type='button' id="shopInfo1Btn" className='shopInfo1Btn blueBtn' onClick={modiBtnEvent}>확인</button>
          </div>
        </div>
      </div>
    </>
  )
})

export default ShopInfo1PopupV22;